import { Box, Stack, Skeleton, useTheme } from '@ltvco/refresh-lib/theme';

const LIST_ITEM_COUNT = 5;

export const TeaserListSkeleton = () => {
  const theme = useTheme();

  return (
    <Stack spacing={1.5}>
      {Array.from({ length: LIST_ITEM_COUNT }).map((_, index) => (
        <Box
          key={index}
          sx={{
            padding: theme.spacing(1.5, 2),
            backgroundColor: theme.palette.background.paper,
            borderRadius: theme.spacing(0.5),
            border: `1px solid ${theme.palette.divider}`,
          }}
        >
          <Stack spacing={1.5} direction="row" alignItems="flex-start">
            <Skeleton
              variant="circular"
              width={40}
              height={40}
              animation="wave"
              sx={{ flexShrink: 0 }}
            />
            <Stack spacing={0.5} sx={{ flex: 1, minWidth: 0 }}>
              <Skeleton
                variant="text"
                width="70%"
                height={24}
                animation="wave"
              />
              <Skeleton
                variant="text"
                width="100%"
                height={16}
                animation="wave"
              />
              <Skeleton
                variant="text"
                width="85%"
                height={16}
                animation="wave"
              />
              <Skeleton
                variant="text"
                width="60%"
                height={16}
                animation="wave"
              />
            </Stack>
            <Skeleton
              variant="rounded"
              width={66}
              height={46}
              animation="wave"
              sx={{ flexShrink: 0 }}
            />
          </Stack>
        </Box>
      ))}
    </Stack>
  );
};
